'use client';

import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';

import { CompetitionStatusEnum } from '@flipster/apis/v2/trading-competition/types';
import { FormattedMessage } from '@flipster/i18n';
import { Button } from '@flipster/react/design-system/button';

import { registerCompetitionBunja } from './action';
import { MaxWidthLayout } from './component/layout';
import { competitionApiBunja, competitionBunja, competitionEventsBunja } from './state';

export const CancelRegistration = () => {
  const { deregisterCompetition } = useBunja(registerCompetitionBunja);
  const { isRegisteredAtom } = useBunja(competitionBunja);
  const { onlyTcEvent } = useBunja(competitionEventsBunja);
  const { competitionStatusAtom } = useBunja(competitionApiBunja);

  const isRegistered = useAtomValue(isRegisteredAtom);
  const competitionStatus = useAtomValue(competitionStatusAtom);

  // TC만 있는 이벤트가 아닌 경우 cancel 시켰을때 사이드 이펙트가 있을수 있어서 cancel 을 막음
  if (!isRegistered || !onlyTcEvent || competitionStatus === CompetitionStatusEnum.Finished) return null;

  return (
    <MaxWidthLayout css={{ textAlign: 'right' }}>
      <Button
        hierarchy='secondary'
        color='neutral'
        size='large'
        disabled={false}
        label={<FormattedMessage id='Autogen_common.r251126.s_Cancel_registration' />}
        onClick={() => deregisterCompetition()}
      />
    </MaxWidthLayout>
  );
};
